import { connect } from 'react-redux';
import { TThunkDispatch, IApplicationState } from '../../types/redux';
import { Complaint } from '../../components/Complaint';
import {
  getComplaints,
  sendComplaint,
  ISendComplaintsParameters,
  sendFeedback,
  ISendFeedbackParameters,
} from '../../actions/complain';
import { changeVisibility } from '../../actions/complain/changeVisibility';

export interface IOwnProps {
  offerCategoriesIds: number[];
  regionId?: number | null;
  offerId: number;
  userEmail?: string;
  fullUrl?: string;
}

export function mapStateToProps(state: IApplicationState, { offerId }: IOwnProps) {
  if (!state.complain[offerId]) {
    return {
      complaints: [],
      isLoading: false,
      isSubmitted: false,
      getUserFeedback: false,
      complaintId: undefined,
      isVisible: false,
    };
  }

  return {
    complaints: state.complain[offerId].complaints,
    isLoading: state.complain[offerId].isLoading,
    isSubmitted: state.complain[offerId].isSubmitted,
    getUserFeedback: state.complain[offerId].getUserFeedback,
    complaintId: state.complain[offerId].complaintId,
    isVisible: state.complain[offerId].isVisible,
  };
}

export function mapDispatchToProps(dispatch: TThunkDispatch, { offerCategoriesIds, regionId, offerId }: IOwnProps) {
  return {
    getComplaints: () => dispatch(getComplaints({ offerCategoriesIds, regionId, offerId })),
    sendComplaint: (args: ISendComplaintsParameters) => dispatch(sendComplaint(args)),
    sendFeedback: (args: ISendFeedbackParameters) => dispatch(sendFeedback(offerId)(args)),
    changeVisibility: (isVisible: boolean) => dispatch(changeVisibility(offerId)(isVisible)),
  };
}

export const ComplainContainer = connect(mapStateToProps, mapDispatchToProps)(Complaint);
